import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=7506d63f&scoped=true"
import script from "./Banner.js?vue&type=script&lang=js&external"
export * from "./Banner.js?vue&type=script&lang=js&external"
import style0 from "./Banner.scss?vue&type=style&index=0&id=7506d63f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7506d63f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default,HotButton: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Button/Button.vue').default})
